export default "__VITE_ASSET__RNlkZyTk__"